module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Action Sheet</span> </header-bar> <scroll-view class=center-block> <button-area> <button text=\"点击弹出 Action Sheet\" @click=showActionSheet() raised></button> <button text=\"不带 cancel 按钮的\" @click=showActionSheet(true) raised></button> </button-area> </scroll-view> <action-sheet :actions=actionSheet.actions :show.sync=actionSheet.show :show-cancel=actionSheet.showCancel></action-sheet> <modal :show.sync=modal.show :title=modal.title :msg=modal.msg></modal> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/actionSheet.vue
 ** module id = 382
 ** module chunks = 1
 **/